import React, {useEffect} from 'react';
import {View} from 'react-native';
import {Text} from '../../../../../../shared/components/text';
import {useStyles} from '../../../../../../shared/hooks/styles';
import {hexToRgbA} from '../../../../../../shared/pipes';
import {useTheme} from '../../../../../../shared/theme';
import {capitalizeLastWord} from '../../../../../../shared/utils/text';
import {Props} from './model';
import {ProfileLinkedAccountStatus} from '../../../../../../shared/models/linkAccount';
import {LoadableContent} from '../../../../../../shared/components/loadableContent';
import {useAccountLinker} from '../../../../../../shared/hooks/useAccountLinkerHook/useAccountLinker';
import {useDispatch} from 'react-redux';
import {addNotification} from '../../../../../../redux/actions/snackbar';
import {SnackbarNotificationType} from '../../../../../../shared/components/snackbar/model';

export default ({linkedAccount, style}: Props) => {
  const {isLoading} = useAccountLinker();
  const dispatch = useDispatch();
  const _theme = useTheme();
  const styles = useStyles(({theme}) => ({
    container: {
      backgroundColor: theme.color.primaryNonGreyBackground,
      borderRadius: 14,
      width: '100%',
    },
    header: {
      minHeight: 45,
      paddingHorizontal: 20,
      paddingVertical: 10,
      position: 'relative',
    },
    body: {
      borderBottomLeftRadius: 14,
      borderBottomRightRadius: 14,
      backgroundColor: hexToRgbA(theme.applications.mobileListItemBodyBg, 0.15),
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 20,
      paddingVertical: 10,
    },
    status: {
      width: 10,
      height: 10,
      position: 'absolute',
      right: 8,
      top: 8,
    },
    textNormal: {
      ...theme.fonts.body,
    },
    textActive: {
      ...theme.fonts.action,
    },
    dateWrapper: {
      width: 128,
    },
    dateText: {
      ...theme.fonts.label,
      color: theme.color.labelText,
    },
    statusWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      flexGrow: 1,
    },
    statusText: {
      ...theme.fonts.bodySmallLight,
      marginLeft: 15,
      textAlign: 'right',
    },
  }));

  const nonActivatedStatuses = [5, 6, undefined];
  const isNeedActivation =
    linkedAccount.cardNumber == null || nonActivatedStatuses.includes(linkedAccount.cardStatusId) ? true : false;

  return (
    <LoadableContent loading={isLoading}>
      <View style={[styles.container, style]}>
        <View style={styles.header}>
          <Text style={styles.textNormal}>{capitalizeLastWord(linkedAccount.counterpartyFullName)}</Text>
        </View>
        <View style={styles.body}>
          <View style={styles.statusWrapper}>
            {!isNeedActivation ? (
              <Text>{`**** **** **** ${linkedAccount.cardNumber}`}</Text>
            ) : (
              <Text style={{color: 'red'}}>{`Требуется активация`}</Text>
            )}
            <Text
              style={[
                styles.statusText,
                {
                  color:
                    _theme.linkedAccounts.statusColors[
                      ProfileLinkedAccountStatus[linkedAccount.status as keyof typeof ProfileLinkedAccountStatus] ||
                        ProfileLinkedAccountStatus.Pending
                    ],
                },
              ]}>
              {linkedAccount.status === 'Accepted' ? 'Подключен' : 'Ожидает'}
            </Text>
          </View>
        </View>
      </View>
    </LoadableContent>
  );
};
